import { render, staticRenderFns } from "./suggestInputPattern.vue?vue&type=template&id=78f4ecfd&scoped=true"
import script from "./suggestInputPattern.vue?vue&type=script&lang=js"
export * from "./suggestInputPattern.vue?vue&type=script&lang=js"
import style0 from "./suggestInputPattern.vue?vue&type=style&index=0&id=78f4ecfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4ecfd",
  null
  
)

export default component.exports